import { useI18n } from "../i18n";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Gem } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";

export const LoyaltyCard = () => {
  const { t, date } = useI18n();
  const { user, setUser } = useAuth();
  const [data, setData] = useState(null);
  const points = user?.loyalty_points || 0;
  useEffect(() => { if (user) api.get("/loyalty").then((r) => setData(r.data)); }, [user, points]);
  if (!user || !data) return null;

  const redeem = async (r) => {
    try {
      const res = await api.post("/loyalty/redeem", { reward_id: r.id });
      setUser(res.data);
      toast.success(t("added", { n: r.credits }));
    } catch (e) { toast.error(t("redeemFail")); }
  };

  return (
    <div className="panel p-6 sm:p-8 grid gap-5" data-testid="loyalty-card">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <span className="label text-violet flex items-center gap-2"><Gem size={13} /> {t("loyalty")}</span>
          <p className="text-sm text-muted mt-2">{t("loyaltyText", { n: data.points_per_euro })}</p>
        </div>
        <div className="text-right">
          <p className="font-mono font-black text-4xl text-violet" data-testid="loyalty-points">{points}</p>
          <p className="label">{t("points")}</p>
        </div>
      </div>
      <div className="grid sm:grid-cols-3 gap-3">
        {data.rewards.map((r) => (
          <button key={r.id} className="reward-btn" onClick={() => redeem(r)} disabled={points < r.points} data-testid={`redeem-${r.id}-btn`}>
            <span className="font-heading text-xl">{r.credits} {t("credits")}</span>
            <span className="font-mono text-xs">{r.points} {t("points")}</span>
          </button>
        ))}
      </div>
      {data.history.length > 0 && (
        <div className="grid gap-1 font-mono text-xs text-subtle" data-testid="loyalty-history">
          {data.history.slice(0, 5).map((h) => (
            <div key={`${h.created_at}-${h.points}`} className="flex justify-between border-b border-line py-1">
              <span>{date(h.created_at)} · {h.reason}</span>
              <span className={h.points > 0 ? "text-violet" : ""}>{h.points > 0 ? "+" : ""}{h.points}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
